import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import LicenseHelp from "./LicenseHelp";
const LicenseExpirationNotification = ({ expiredSince, products }) => {
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  const productNames = products.length > 0 ? products.join(", ") : productName;
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: "has-bm", title: t("license.notifications.expired_title", { productName }) }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "license.notifications.expired",
      count: products.length > 1 ? 2 : 1,
      values: { products: productNames, since: expiredSince },
      components: { strong: /* @__PURE__ */ React.createElement("strong", null), licenseHelp: /* @__PURE__ */ React.createElement(LicenseHelp, null) }
    }
  )));
};
export default LicenseExpirationNotification;
